import React from 'react';
import { modelPlatforms } from '../../data/stack';
import { ModelPlatform } from '../../types/content';
import { CountResult } from '../../utils/api';
import { OPENROUTER_API } from '../../utils/sourceIndex';
import { formatInt } from '../../utils/format';
import { DataBadge } from '../DataBadge';
import { SourceRef } from '../SourceRef';
const TYPE_STYLE: Record<ModelPlatform['type'], string> = {
  Router: 'border-machine/40 text-machine',
  'Inference cloud': 'border-human/40 text-human',
  'First-party': 'border-line text-muted'
};
export function ModelPlatformsTab({
  openrouter
}: {
  openrouter: CountResult | null;
}) {
  return <section aria-labelledby="model-platforms-title" data-id="element-457" data-mp="2sr97ojv9ltlh">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-458" data-mp="2xrx7nv1h1kru">
        <div data-id="element-459" data-mp="82bqdn7pyflp">
          <h2 id="model-platforms-title" className="font-serif text-2xl text-ink md:text-3xl" data-id="element-460" data-mp="82ld91xgw6n6">
            Where models are served
          </h2>
          <p className="mt-2 max-w-2xl text-[14px] text-muted" data-id="element-461" data-mp="czv32iorqkbj">Routers aggregate many providers behind one API; inference clouds host open models; first-party APIs serve a lab’s own models.</p>
        </div>
        <DataBadge mode={openrouter ? openrouter.mode : 'loading'} source="OpenRouter models API" asOf={openrouter?.asOf} data-id="element-462" data-mp="dnp3jrl6xnjw" />
      </div>
      <div className="mt-5 overflow-x-auto rounded-lg border border-line" data-id="element-463" data-mp="3oq32wakwy7z">
        <table className="w-full min-w-[1040px] border-collapse text-[13.5px]" data-id="element-464" data-mp="3qu6ld4kfv7q">
          <thead className="bg-surface text-left text-[12px] text-muted" data-id="element-465" data-mp="3uwlyagxzrfwn">
            <tr data-id="element-466" data-mp="3q39i8v7dohfi">
              {['Platform', 'Type', 'Models served', 'Pricing model', 'Notable feature'].map(h => <th key={h} scope="col" className="whitespace-nowrap border-b border-line px-3 py-2.5 font-normal" data-id="element-467" data-mp="3m38rcb33edrk">
                  {h}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-468" data-mp="3c3rnlz7ei9y8">
            {modelPlatforms.map(p => <tr key={p.name} className="border-b border-line/60 last:border-b-0" data-id="element-469" data-mp="3756raav9saf2">
                <th scope="row" className="whitespace-nowrap px-3 py-3 text-left font-normal text-ink" data-id="element-470" data-mp="2xhb4w0ce7m8b">
                  {p.name}
                  <SourceRef href={p.sourceUrl} data-id="element-471" data-mp="32hqkkyk5d5tg" />
                  {p.pulled && <span className="ml-2 rounded border border-live/40 px-1.5 py-px font-mono text-[10px] text-live" data-id="element-472" data-mp="2oho2bb7xgado">we pull this API</span>}
                </th>
                <td className="whitespace-nowrap px-3 py-3" data-id="element-473" data-mp="2sku6mdbhbrhi">
                  <span className={`rounded border px-1.5 py-0.5 font-mono text-[10.5px] ${TYPE_STYLE[p.type]}`} data-id="element-474" data-mp="3g9dfatyfy6a4">{p.type}</span>
                </td>
                <td className="px-3 py-3 font-mono text-[12.5px] text-ink" data-id="element-475" data-mp="3l99i4pvejro3">
                  {p.models === 'live' ? <>
                      {openrouter ? formatInt(openrouter.count) : '…'} models
                      <SourceRef href={OPENROUTER_API} data-id="element-476" data-mp="31acd927ecvj" />
                      {openrouter && <span className={`ml-1.5 text-[10.5px] ${openrouter.mode === 'live' ? 'text-live' : 'text-machine'}`} data-id="element-477" data-mp="2zz714t40x2b">{openrouter.mode}</span>}
                    </> : <span className={p.models.includes('—') || p.models.startsWith('Not') ? 'text-faint' : ''} data-id="element-478" data-mp="1sgl0tacq51na">{p.models}</span>}
                </td>
                <td className="px-3 py-3 text-muted" data-id="element-479" data-mp="227fqypt3cle0">{p.pricing}</td>
                <td className="px-3 py-3 text-ink/85" data-id="element-480" data-mp="1x94h4f2sqavs">{p.feature}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-[12px] text-muted" data-id="element-481" data-mp="19kbp2tpaon6g">
        <span className="text-live" data-id="element-482" data-mp="14li98umjck34">we pull this API</span> — OpenRouter feeds the live model count above; Hugging Face feeds the live layer on the Models page.
      </p>
    </section>;
}